<template>
  <el-button
    class="ai-action-button"
    :loading="loading"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span class="ai-action-button__content">
      <span v-if="!loading" class="ai-action-button__icon">
        <img src="https://oss.kaoyanvip.cn/attach/file1789625490189.png" alt="" />
      </span>
      <span class="ai-action-button__text"><slot></slot></span>
    </span>
  </el-button>
</template>

<script>
export default {
  name: "AiActionButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.ai-action-button.el-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 118px;
  height: 38px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #7357ff 0%, #4b7dff 52%, #27b7ff 100%);
  box-shadow: 0 6px 16px rgba(76, 102, 255, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

  &:not(.is-disabled):not(.is-loading):hover,
  &:not(.is-disabled):not(.is-loading):focus {
    color: #fff;
    background: linear-gradient(135deg, #8068ff 0%, #5889ff 52%, #3ac0ff 100%);
    box-shadow: 0 8px 20px rgba(76, 102, 255, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.32);
    transform: translateY(-1px);
  }

  &:not(.is-disabled):not(.is-loading):active {
    box-shadow: 0 3px 10px rgba(76, 102, 255, 0.28);
    transform: translateY(0);
  }

  &.is-disabled {
    color: #a8abb2;
    background: #ebeef5;
    box-shadow: none;
  }
}

.ai-action-button__content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.ai-action-button__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-right: 7px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 6px rgba(39, 54, 142, 0.16);
  flex-shrink: 0;

  img {
    width: 16px;
    height: 16px;
  }
}

.ai-action-button__text {
  line-height: 16px;
}
</style>
